import { Card, CardContent, View, Image } from "@/components/ui";
import { Typography } from "@/components/shared/typography";
import CalendarChecklist from "@/assets/images/3d-icons/calendar-checklist.png";

export const BookingConfirmationCard = () => {
  return (
    <Card className="shadow-slate-200" border="none" shadow="lg">
      <CardContent className="p-4">
        <View className="flex flex-col items-center gap-2">
          <View className="h-10 w-10">
            <Image src={CalendarChecklist} className="w-full" />
          </View>
          <Typography variant="label-md" color="brand-primary">
            We're excited to serve you
          </Typography>
          <Typography variant="body-sm" color="secondary-text" align="center">
            Your booking is confirmed! Sit back, relax, and let us take care of
            everything so you can enjoy the results stress-free.
          </Typography>
        </View>
      </CardContent>
    </Card>
  );
};
